export const comments = [
  {
    id: 1,
    author: '吃瓜群众甲',
    content: '这个网站真的太及时了，每天都有最新爆料，已经推荐给身边的朋友了！黑料网入口收藏夹必备。',
    time: '2小时前',
    likes: 128,
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20warm%20gray%20tone%20and%20soft%20circular%20gradient%20background%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20user%20icon%20feel%2C%20editorial%20quality&width=80&height=80&seq=avatar-01&orientation=squarish'
  },
  {
    id: 2,
    author: '深度爆料人',
    content: '作为老用户，黑料网官网的更新速度确实快，很多一手信息都是从这里先看到的，强烈推荐关注黑料网最新入口。',
    time: '5小时前',
    likes: 96,
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20warm%20amber%20tone%20and%20soft%20circular%20gradient%20background%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20user%20icon%20feel%2C%20editorial%20quality&width=80&height=80&seq=avatar-02&orientation=squarish'
  },
  {
    id: 3,
    author: '八卦达人',
    content: '整理得很全面，而且分类清晰，找资讯特别方便，黑料网网址大全已经设为主页，每天必刷。',
    time: '8小时前',
    likes: 74,
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20warm%20crimson%20tone%20and%20soft%20circular%20gradient%20background%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20user%20icon%20feel%2C%20editorial%20quality&width=80&height=80&seq=avatar-03&orientation=squarish'
  },
  {
    id: 4,
    author: '新闻追踪者',
    content: '内容质量很高，不是那种乱编的，每条都有来源可查，值得信赖。黑料网站首页做的也很清爽。',
    time: '1天前',
    likes: 203,
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20placeholder%20with%20warm%20slate%20tone%20and%20soft%20circular%20gradient%20background%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20user%20icon%20feel%2C%20editorial%20quality&width=80&height=80&seq=avatar-04&orientation=squarish'
  },
];

export const cards = [
  {
    id: 1,
    title: '娱乐圈最新爆料汇总：多位艺人私生活曝光引发热议',
    desc: '近日娱乐圈接连爆出多起重磅消息，涉及多位一线艺人的私生活内幕，相关话题持续霸占热搜榜，粉丝群体反应激烈，各方当事人尚未正式回应。',
    tag: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20with%20warm%20red%20and%20dark%20tones%2C%20abstract%20celebrities%20and%20paparazzi%20concept%2C%20news%20magazine%20aesthetic%2C%20cinematic%20lighting%2C%20professional%20photojournalism%20style%2C%20clean%20background%20with%20subtle%20grain%20texture%2C%20high%20contrast%2C%20editorial%20quality&width=800&height=500&seq=card-01&orientation=landscape',
    date: '2026-07-30',
    views: '12.8万',
    hot: true,
  },
  {
    id: 2,
    title: '互联网大厂内部裁员真相：员工匿名揭密真实内幕',
    desc: '某头部互联网公司被曝大规模裁员背后另有隐情，多位匿名员工通过黑料网站曝光了公司的真实运营状况和管理层决策内幕。',
    tag: '互联网',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20office%20interior%20with%20dramatic%20lighting%2C%20empty%20desks%20and%20computers%2C%20dark%20atmosphere%20with%20warm%20accents%2C%20investigative%20journalism%20mood%2C%20professional%20photojournalism%20style%2C%20clean%20editorial%20composition%2C%20high%20contrast%20shadows&width=800&height=500&seq=card-02&orientation=landscape',
    date: '2026-07-29',
    views: '9.6万',
  },
  {
    id: 3,
    title: '网红直播带货翻车实录：虚假宣传与产品质量问题频出',
    desc: '近期多位知名网红被指直播带货中存在严重虚假宣传行为，实际产品质量与宣传严重不符，消费者维权困难重重，相关监管部门已介入调查。',
    tag: '直播圈',
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20dramatic%20overhead%20lighting%2C%20abstract%20digital%20commerce%20concept%2C%20warm%20red%20and%20dark%20aesthetic%2C%20editorial%20photojournalism%20style%2C%20consumer%20products%20scattered%20artistically%2C%20high%20contrast%2C%20professional%20composition&width=800&height=500&seq=card-03&orientation=landscape',
    date: '2026-07-28',
    views: '15.3万',
    hot: true,
  },
  {
    id: 4,
    title: '金融圈大佬离婚案：百亿财产分割背后的家族恩怨',
    desc: '某知名金融集团掌门人离婚案近日开庭审理，涉及数百亿资产分割，家族内部矛盾白热化，多份内部文件被曝光，引发金融圈震动。',
    tag: '金融圈',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20corporate%20law%20office%20interior%20with%20dramatic%20lighting%2C%20legal%20documents%20and%20financial%20charts%2C%20dark%20warm%20atmosphere%2C%20investigative%20journalism%20feel%2C%20professional%20editorial%20photography%2C%20high%20contrast%20shadows%2C%20clean%20composition&width=800&height=500&seq=card-04&orientation=landscape',
    date: '2026-07-27',
    views: '8.2万',
  },
  {
    id: 5,
    title: '体育界丑闻连环爆：知名运动员涉嫌违规操作',
    desc: '体育圈近日不太平，多名知名运动员被指涉嫌违规使用禁药、操纵比赛结果等严重问题，相关体育协会已启动调查程序，后续发展备受关注。',
    tag: '体育圈',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20sports%20stadium%20interior%20with%20moody%20lighting%2C%20empty%20field%20with%20spotlight%20shadows%2C%20dark%20atmosphere%20with%20warm%20amber%20accents%2C%20investigative%20journalism%20mood%2C%20professional%20photojournalism%20style%2C%20high%20contrast%20composition&width=800&height=500&seq=card-05&orientation=landscape',
    date: '2026-07-26',
    views: '11.1万',
  },
  {
    id: 6,
    title: '地产界黑幕深扒：某知名开发商资金链断裂内情',
    desc: '地产行业寒冬持续，多家知名房企被曝资金链紧张甚至断裂，内部员工向黑料网透露了真实的经营状况和潜在的烂尾楼风险。',
    tag: '地产圈',
    image: 'https://readdy.ai/api/search-image?query=Modern%20construction%20site%20at%20dusk%20with%20dramatic%20sky%2C%20half-finished%20buildings%20silhouette%2C%20dark%20warm%20atmosphere%2C%20investigative%20journalism%20feel%2C%20professional%20photojournalism%20style%2C%20high%20contrast%20shadows%2C%20clean%20editorial%20composition&width=800&height=500&seq=card-06&orientation=landscape',
    date: '2026-07-25',
    views: '7.5万',
  },
];

export const rankings = [
  { id: 1, title: '某顶流艺人涉嫌偷税漏税被约谈', tag: '娱乐圈', hot: true, views: '258万' },
  { id: 2, title: '知名科技公司创始人被曝学历造假', tag: '互联网', hot: true, views: '201万' },
  { id: 3, title: '网红主播背后公会合同陷阱大揭秘', tag: '直播圈', views: '187万' },
  { id: 4, title: '健身房连锁品牌老板跑路内幕', tag: '消费圈', views: '156万' },
  { id: 5, title: '教育机构卷款跑路受害者维权实录', tag: '教育圈', views: '132万' },
];

export const topics = [
  { id: 1, name: '明星八卦', count: '3.2万帖', hot: true },
  { id: 2, name: '企业内幕', count: '2.8万帖', hot: true },
  { id: 3, name: '网红翻车', count: '2.5万帖', hot: true },
  { id: 4, name: '社会事件', count: '2.3万帖' },
  { id: 5, name: '骗局曝光', count: '2.1万帖' },
  { id: 6, name: '政商关系', count: '1.9万帖' },
  { id: 7, name: '情感纠纷', count: '1.7万帖' },
  { id: 8, name: '学术造假', count: '1.5万帖' },
  { id: 9, name: '食品安全', count: '1.4万帖' },
];

export const carouselItems = [
  {
    id: 1,
    title: '深度调查：直播带货行业的灰色产业链',
    desc: '从选品、刷单到虚假宣传，一条完整的灰色产业链正在直播带货行业蔓延，涉及多方利益。本专题将持续追踪最新进展。',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20modern%20live%20streaming%20industry%20with%20warm%20red%20and%20dark%20tones%2C%20sophisticated%20investigative%20journalism%20aesthetic%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20photojournalism%2C%20abstract%20digital%20commerce%20elements%2C%20clean%20composition%2C%20high%20contrast&width=1200&height=600&seq=carousel-01&orientation=landscape',
    date: '2026-07-30',
  },
  {
    id: 2,
    title: '娱乐圈资本局：那些你不知道的资本运作真相',
    desc: '娱乐圈背后隐藏着复杂的资本网络，从对赌协议到股权代持，本专题为您揭开明星光鲜背后的资本江湖。',
    tag: '专题策划',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20luxury%20entertainment%20industry%20behind%20scenes%2C%20warm%20red%20and%20dark%20atmosphere%2C%20sophisticated%20investigative%20journalism%20style%2C%20cinematic%20lighting%2C%20professional%20photojournalism%2C%20abstract%20wealth%20concept%2C%20clean%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    date: '2026-07-29',
  },
  {
    id: 3,
    title: '互联网裁员潮下的生存现状：员工真实讲述',
    desc: '各大互联网公司持续裁员，我们收集了数十位被裁员工的真实经历，还原这个寒冬里的生存百态。',
    tag: '专题报道',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20modern%20tech%20office%20with%20empty%20workspaces%2C%20warm%20amber%20and%20dark%20tones%2C%20investigative%20journalism%20aesthetic%2C%20cinematic%20lighting%20with%20long%20shadows%2C%20professional%20photojournalism%2C%20clean%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
    date: '2026-07-28',
  },
  {
    id: 4,
    title: '食品安全黑名单：半年内被曝光的品牌全纪录',
    desc: '2026年上半年，多家知名食品品牌因安全问题被曝光。我们整理了完整的时间线和涉事品牌名单。',
    tag: '数据盘点',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20food%20safety%20inspection%20concept%2C%20warm%20red%20and%20dark%20atmosphere%2C%20investigative%20journalism%20style%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20professional%20photojournalism%2C%20abstract%20food%20industry%20elements%2C%20clean%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    date: '2026-07-27',
  },
  {
    id: 5,
    title: '医美行业乱象调查：无证行医与天价收费',
    desc: '医美行业蓬勃发展背后隐藏着大量无证行医、虚假宣传、天价收费等问题，多位受害者向本报讲述亲身经历。',
    tag: '行业调查',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20modern%20medical%20aesthetic%20clinic%20interior%2C%20warm%20red%20and%20dark%20atmosphere%2C%20investigative%20journalism%20style%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20photojournalism%2C%20clean%20composition%2C%20sophisticated%20mood&width=1200&height=600&seq=carousel-05&orientation=landscape',
    date: '2026-07-26',
  },
  {
    id: 6,
    title: 'P2P爆雷受害者群像：五年过去了，钱还没要回来',
    desc: '距离上一轮P2P爆雷潮已过去五年，大量受害者的资金至今未能追回。我们回访了数十位受害者，记录他们的维权之路。',
    tag: '持续追踪',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photo%20of%20financial%20documents%20and%20legal%20papers%2C%20warm%20amber%20and%20dark%20atmosphere%2C%20investigative%20journalism%20style%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20photojournalism%2C%20clean%20composition&width=1200&height=600&seq=carousel-06&orientation=landscape',
    date: '2026-07-25',
  },
];

export const indexItems = [
  { id: 1, title: '娱乐圈八卦', icon: 'ri-star-line', desc: '明星动态、恋情曝光、综艺内幕', count: '1,286条' },
  { id: 2, title: '互联网爆料', icon: 'ri-computer-line', desc: '大厂内幕、裁员真相、产品争议', count: '1,052条' },
  { id: 3, title: '金融圈黑幕', icon: 'ri-money-dollar-circle-line', desc: '资本运作、财务造假、内幕交易', count: '893条' },
  { id: 4, title: '社会热点', icon: 'ri-fire-line', desc: '公共事件、民生问题、政策解读', count: '1,417条' },
  { id: 5, title: '直播带货乱象', icon: 'ri-live-line', desc: '虚假宣传、产品质量、售后维权', count: '764条' },
  { id: 6, title: '地产圈风云', icon: 'ri-building-line', desc: '烂尾楼、资金链、物业纠纷', count: '631条' },
  { id: 7, title: '教育圈丑闻', icon: 'ri-book-open-line', desc: '学术造假、师德问题、机构跑路', count: '589条' },
  { id: 8, title: '医疗健康曝光', icon: 'ri-heart-pulse-line', desc: '药品安全、医疗事故、医美乱象', count: '475条' },
];

export const updates = [
  { id: 1, date: '2026-07-30', title: '黑料网站移动端适配完成，手机浏览体验全面升级', tag: '站点公告' },
  { id: 2, date: '2026-07-28', title: '新增「直播带货乱象」专题频道，汇总近期直播翻车事件', tag: '内容更新' },
  { id: 3, date: '2026-07-25', title: '服务器扩容完成，访问速度提升50%，支持更高并发访问', tag: '技术升级' },
  { id: 4, date: '2026-07-22', title: '新增用户匿名投稿功能，投稿审核通过后可获得曝光推荐', tag: '功能更新' },
  { id: 5, date: '2026-07-18', title: '与多家独立调查媒体达成内容合作，独家爆料持续增加', tag: '合作动态' },
  { id: 6, date: '2026-07-15', title: '网站安全证书升级，全面启用HTTPS加密，保护用户隐私安全', tag: '安全公告' },
  { id: 7, date: '2026-07-10', title: '黑料网APP内侧版本上线，iOS与Android同步发布', tag: '产品发布' },
  { id: 8, date: '2026-07-05', title: '上半年黑料爆料大数据发布：娱乐圈类内容阅读量突破5亿', tag: '数据报告' },
];

export const mediaItems = [
  {
    id: 1,
    title: '独家专访：前娱乐圈经纪人爆料行业内幕',
    desc: '一位在娱乐圈摸爬滚打15年的资深经纪人，首次公开讲述她所经历的行业内幕和潜规则。',
    tag: '独家专访',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20interview%20scene%20with%20warm%20dramatic%20lighting%2C%20professional%20documentary%20style%2C%20dark%20background%20with%20rim%20light%2C%20investigative%20journalism%20aesthetic%2C%20clean%20composition%2C%20high%20contrast%2C%20editorial%20quality&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '18:42',
  },
  {
    id: 2,
    title: '深度调查：网红直播间的虚假流量从何而来',
    desc: '深入调查直播行业流量造假产业链，揭秘机器人观众、刷量软件的运作方式和背后利益链。',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20documentary%20style%20image%20of%20digital%20data%20analytics%20dashboard%2C%20warm%20red%20and%20dark%20atmosphere%2C%20investigative%20journalism%20mood%2C%20professional%20photojournalism%2C%20clean%20composition%2C%20high%20contrast%20shadows&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '22:15',
  },
  {
    id: 3,
    title: '现场直击：P2P受害者法院维权全过程',
    desc: '跟随P2P爆雷受害者走进法院，完整记录立案、庭审到宣判的维权全过程和最终结果。',
    tag: '现场直击',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20photo%20of%20courthouse%20interior%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20tones%2C%20documentary%20style%2C%20professional%20photojournalism%2C%20legal%20atmosphere%2C%20clean%20composition%2C%20high%20contrast&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '15:30',
  },
  {
    id: 4,
    title: '揭秘系列：医美行业你不知道的十个真相',
    desc: '从业内人士视角出发，揭露医美行业从定价、耗材到资质的十大不为人知的真相和陷阱。',
    tag: '揭秘系列',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20photo%20of%20modern%20medical%20aesthetic%20operation%20room%2C%20warm%20red%20and%20dark%20atmosphere%2C%20documentary%20style%2C%20investigative%20journalism%20mood%2C%20professional%20photojournalism%2C%20clean%20composition%2C%20high%20contrast&width=640&height=360&seq=media-04&orientation=landscape',
    duration: '25:08',
  },
  {
    id: 5,
    title: '圆桌讨论：互联网裁员潮还会持续多久',
    desc: '邀请多位互联网从业者和HR专家，从不同角度分析当前裁员潮的成因、影响和未来走向。',
    tag: '圆桌讨论',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20photo%20of%20roundtable%20discussion%20in%20modern%20office%2C%20warm%20amber%20and%20dark%20atmosphere%2C%20documentary%20style%2C%20professional%20photojournalism%2C%20corporate%20setting%2C%20clean%20composition%2C%20high%20contrast&width=640&height=360&seq=media-05&orientation=landscape',
    duration: '32:50',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '黑料网站是什么？提供哪些内容？',
    answer: '黑料网站是一个专注于社会热点事件深度报道与内幕爆料的资讯聚合平台，提供娱乐圈八卦、互联网企业内幕、直播带货乱象、金融圈黑幕、社会事件等方面的最新资讯和深度调查报道。我们致力于为用户提供真实、及时、有深度的新闻内容。',
  },
  {
    id: 2,
    question: '黑料网最新入口在哪里？如何找到正确的官网地址？',
    answer: '您当前访问的页面就是黑料网站官方首页入口。建议将本页面加入浏览器收藏夹，以便随时快速访问。我们也会在页脚区域持续更新最新的官方入口地址和备用域名信息，确保用户能够稳定访问。',
  },
  {
    id: 3,
    question: '黑料网站的爆料信息可靠吗？有来源验证吗？',
    answer: '我们坚持真实、客观的报道原则，每条爆料信息都会经过编辑团队的多方核实和交叉验证，确保内容的可靠性。重要的调查报道会注明信息来源，让读者可以自行查证。我们拒绝发布未经核实的虚假信息。',
  },
  {
    id: 4,
    question: '如何在黑料网投稿或爆料？投稿后会得到回复吗？',
    answer: '您可以通过页面中的「联系我们」板块找到投稿渠道。所有投稿都会由编辑团队认真审核，符合发布标准的爆料会在核实后刊登。我们严格保护投稿人的隐私安全，绝不会泄露投稿人的个人信息。审核通过的内容会在一周内给予回复。',
  },
  {
    id: 5,
    question: '黑料网站有移动端APP吗？用手机访问方便吗？',
    answer: '黑料网已经完成移动端全面适配，直接用手机浏览器访问即可获得良好的浏览体验。同时，我们的APP已在内测阶段，支持iOS和Android双平台，预计近期正式上线发布，届时会在网站显著位置公布下载入口。',
  },
  {
    id: 6,
    question: '黑料网站的内容更新频率是怎样的？',
    answer: '我们的编辑和调查团队保持7×24小时不间断工作，每天更新大量最新资讯和深度报道。重大突发事件会在第一时间跟进报道，深度调查专题则保持每周至少2-3篇的稳定产出，确保用户能够持续获取新鲜、有价值的内容。',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '每条爆料经过多方核实与交叉验证，确保内容真实可信，拒绝虚假信息和谣言传播，为用户提供负责任的资讯服务。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '快速及时',
    desc: '7×24小时全天候运营，重大突发事件第一时间跟进报道，热点资讯即时推送，让用户永远站在信息前沿，不错过任何重要爆料。',
  },
  {
    id: 3,
    icon: 'ri-lock-line',
    title: '隐私安全',
    desc: '投稿人信息严格保密，采用先进的加密技术保护用户数据，匿名投稿通道确保爆料人在安全的环境下分享信息，绝不泄露任何个人信息。',
  },
];

export const aboutContent = {
  title: '关于黑料网站',
  paragraphs: [
    '黑料网站成立于2020年，是国内领先的社会热点事件深度报道与内幕资讯聚合平台。我们汇聚了一批资深调查记者和行业内部人士，致力于为用户提供真实、客观、深度的新闻资讯服务。',
    '平台覆盖娱乐圈八卦、互联网企业内幕、直播带货乱象、金融圈黑幕、地产圈风云、教育医疗等多个领域，目前已累计发布深度调查报道超过5,000篇，日均访问用户超过百万。',
    '我们秉持「真实即力量」的理念，坚持独立、客观的报道立场，不迎合、不妥协，为公众还原事件真相，推动社会进步。未来，黑料网站将继续扩展内容覆盖面，提升报道质量，打造华语世界最值得信赖的爆料资讯平台。',
  ],
  stats: [
    { value: '5,000+', label: '深度报道' },
    { value: '100万+', label: '日均用户' },
    { value: '15+', label: '内容频道' },
  ],
};

export const appContent = {
  title: '随时随地，掌握最新爆料',
  desc: '黑料网APP正在内测中，支持iOS与Android双平台。下载APP即可享受推送通知、离线阅读、夜间模式等专属功能，精彩爆料不再错过。',
  features: ['实时推送重大爆料', '离线缓存随时阅读', '夜间模式护眼浏览', '匿名投稿一键直达'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20news%20app%20interface%20with%20dark%20theme%2C%20warm%20red%20and%20charcoal%20color%20scheme%2C%20clean%20editorial%20design%2C%20news%20headlines%20visible%20on%20screen%2C%20professional%20product%20photography%2C%20minimalist%20composition%2C%20soft%20studio%20lighting&width=600&height=800&seq=app-mockup&orientation=portrait',
};